import { createPortal } from 'react-dom';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { subscribeShopify } from '@/service/common';

export default function QuestionModal({ input, link, callback }: any) {
    const { useEffect, useState, useRouter, useLang, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('dp3.teaser.Recommend');
    const [isClient, setIsClient] = useState(false);

    const handleJoinCommunity = async () => {
        const date = new Date();

        // 格式化时间
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const dateString = `${year}-${month}-${day}`;

        // 订阅SMS
        const dataSMS = {
            email: input.trim(),
            contactListId: '1705576574',
            fields: [
                // SMS
                {
                    id: '10791',
                    type: 'text',
                    overwrite: true,
                    value: dateString,
                },
                {
                    id: '10615',
                    type: 'multiple',
                    value: [3],
                    overwrite: false,
                },
                {
                    id: locale === 'us' ? '4423' : locale === 'ca' ? '4424' : '',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '10875',
                    type: 'multiple',
                    value: [1],
                    overwrite: false,
                },
            ],
        };
        const res = await subscribeShopify(dataSMS, locale, { sector_name: t('modal_title'), entry_position: 2 });
        if (res?.code === '0') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('subscribe_btn'),
                status: 'success',
                tag: 'Agree',
            });
            return true;
        } else {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('subscribe_btn'),
                status: 'fail',
                tag: 'Agree',
            });
            return true;
        }
    };
    //根据后端要求,10秒后再执行;但考虑用户体验,不能让用户在这里等待10s
    const handleJoinCommunityHandle = () => {
        setTimeout(() => {
            handleJoinCommunity();
        }, 10000);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            {isClient &&
                createPortal(
                    <div className={`question-modal ${css['question-modal']}`}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <span className="close" onClick={callback}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M6 5L19 18M19 5L6 18" stroke="black" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                            </div>
                            <div className="modal-body">
                                <p className="modal-text">{t('modal_title')}</p>
                                <a className="modal-link" href={link} onClick={handleJoinCommunityHandle} target="_blank" rel="noreferrer">
                                    {t('modal_join')}
                                </a>
                            </div>
                        </div>
                        <style jsx global>
                            {`
                                .announcement-bar {
                                    z-index: 100;
                                }
                                .ecoflow-frame-header {
                                    z-index: 150 !important;
                                }
                                .festival-float {
                                    z-index: 180;
                                }
                            `}
                        </style>
                    </div>,
                    document.body,
                )}
        </>
    );
}
